import { createContext } from "react";
import { SchoolAdminModalContextInterface } from "../../Interfaces/ContextInterfaces/SchoolAdminModalContextInterface";

const SchoolAdminModalContext = createContext<SchoolAdminModalContextInterface | undefined>(undefined);

export default SchoolAdminModalContext;